import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { WelcomeComponent } from './welcome/welcome.component';
import { ErrorPageComponent } from './core/error-page/error-page.component';


import { SurveyComponent } from './result/survey/survey.component';
import { HrAuthGuard } from './auth/hr-auth-guard.service';
import { AuthGuard } from './auth/auth-guard.service';
import { IntroComponent } from './intro/intro.component';
import { AuthGuardNone } from './auth/auth-guard-none';
import { AuthGuardSuper } from './auth/auth-guard-super';
import { ContentEditorComponent } from './content-editor/content-editor.component';
import { MassSectionComponent } from './mass-section/mass-section.component';
import { TagManagementComponent } from './tag-management/tag-management.component';


const appRoutes: Routes = [
  { path: 'intro', component:IntroComponent, canActivate: [AuthGuard] },
  { path: 'welcome', component: WelcomeComponent , canActivate: [AuthGuard] },
  { path: 'not-found', component: ErrorPageComponent, data: { message: 'Page not found!' } },


  { path: 'result/survey', component: SurveyComponent },
  { path: 'complete', component: SurveyComponent },
  { path: 'content-editor/:id', component: ContentEditorComponent },
  { path: 'content-editor', component: ContentEditorComponent },
  { path: 'mass-section', component: MassSectionComponent },
  { path: 'tags', component: TagManagementComponent }

];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { preloadingStrategy: PreloadAllModules, enableTracing: false })
  ],
  exports: [RouterModule],
  providers: [
    AuthGuard,
    HrAuthGuard,
    AuthGuardNone,
    AuthGuardSuper
  ]
})
export class AppRoutingModule {

}
